<template>
  <!--begin::Navbar-->
  <div class="app-navbar flex-shrink-0">
    <div
      class="mt-5"
      v-if="
        this.user && this.user.User && this.user.User.Emitente.tipo_pacote == 0
      "
    >
      <button
        data-bs-toggle="modal"
        data-bs-target="#kt_modal_upgrade_plan"
        type="button"
        class="btn btn-sm btn-light btn-active-light-primary"
      >
        <span class="svg-icon svg-icon-1 lh-0 btn-icon">
          <inline-svg src="media/icons/duotune/general/gen002.svg" />
        </span>
        Atualizar Plano
      </button>
    </div>
    <div class="app-navbar-item ms-1 ms-md-4">
      <router-link
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Ajuda"
        to="/suporte/ajuda/consultar"
        class="btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px"
      >
        <span class="svg-icon svg-icon-2">
          <inline-svg src="media/icons/duotune/general/gen046.svg" />
        </span>
      </router-link>
    </div>
    <div id="kt_header_change_theme" class="app-navbar-item ms-1 ms-lg-3">
      <a
        href="#"
        class="btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px"
        data-kt-menu-trigger="{default:'click', lg: 'hover'}"
        data-kt-menu-attach="parent"
        data-kt-menu-placement="bottom-end"
      >
        <span
          v-if="themeMode === 'light'"
          class="svg-icon theme-dark-hide svg-icon-2"
        >
          <inline-svg src="media/icons/duotune/general/gen060.svg" />
        </span>
        <span v-else class="svg-icon theme-light-hide svg-icon-2">
          <inline-svg src="media/icons/duotune/general/gen061.svg" />
        </span>
      </a>
      <KTThemeModeSwitcher />
    </div>
    <div class="app-navbar-item ms-1 ms-lg-3" id="kt_header_user_menu_toggle">
      <div
        class="cursor-pointer symbol symbol-35px symbol-md-40px"
        data-kt-menu-trigger="click"
        data-kt-menu-attach="parent"
        data-kt-menu-placement="bottom-end"
      >
        <img
          v-if="
            this.user &&
            this.user.User &&
            this.user.User.UsuarioDado &&
            this.user.User.UsuarioDado.foto
          "
          alt="Logo"
          :src="this.$utils.getUrl() + this.user.User.UsuarioDado.foto"
        />
        <img v-else alt="Logo" src="media/avatars/blank.png" />
      </div>
      <KTUserMenu />
    </div>
    <div class="app-navbar-item d-lg-none ms-2 me-n3" title="Show header menu">
      <div
        class="btn btn-icon btn-active-color-primary w-35px h-35px"
        id="kt_app_header_menu_toggle"
      >
        <span class="svg-icon svg-icon-1">
          <inline-svg src="media/icons/duotune/text/txt001.svg" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import KTUserMenu from "@/layouts/main-layout/menus/UserAccountMenu.vue";
import KTThemeModeSwitcher from "@/layouts/main-layout/theme-mode/ThemeModeSwitcher.vue";
import { useStore, mapState } from "vuex";

export default defineComponent({
  name: "header-navbar",
  components: {
    KTUserMenu,
    KTThemeModeSwitcher,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  setup() {
    const store = useStore();

    const themeMode = computed(() => {
      return store.getters.getThemeMode;
    });

    return {
      themeMode,
    };
  },
});
</script>
